<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
import axios from 'axios';
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Manufacturing Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,
  },
  data() {
    return {
      title: "MANUFACTURING REPORT",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "MANUFACTURING REPORT",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },        
        {
          key: "account",
          sortable: true,
          label: "PARTICULARS",
        },
        {
          key: "dr",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "cr",
          sortable: true,
          label: "AMOUNT",
        }
      ],
      
      // make inputs required
      accountError: "",
      amountError: "",
      // delete category
      deletedata: {
        name: "",
        id: "",
      },
      total_credit:0,
      total_debit:0,      

      filterData: {
        time: "annual",
        datefrom: new Date(new Date().getFullYear(), 0, 1).toLocaleDateString('en-CA'),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        year: new Date().getFullYear(),
        branch_id:0,
        report:""
      },
      dashboardLabel: new Date().getFullYear()+"'s", 
      timeFilters: [
        { title: "Annual", value: "annual" },
        { title: "This month", value: "month" },
        { title: "This quarter", value: "quarter" },
        { title: "Customize", value: "custom" },
      ],
      currentYear: new Date().getFullYear(),
      ReportDetails:[]      
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
     ...mapGetters("consumables", ["ManufacturingReport","FilterStatus","ManufacturingReportDetails"]),
    ...mapGetters("auth", ["MyUserPerm"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.ManufacturingReport ? this.ManufacturingReport.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ManufacturingReport ? this.ManufacturingReport.length : 1;
  },
  // updated(){
  // },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },

    'filterData.dateRange': function (newDateRange) {
      // Check if the selected date range is outside the current year
      if (
        newDateRange[0].getFullYear() !== this.currentYear ||
        newDateRange[1].getFullYear() !== this.currentYear
      ) {
        // If outside the current year, reset the date range
        this.filterData.dateRange = [];
      }
    },
    ManufacturingReportDetails(newValue){
      if(newValue){
        this.ReportDetails = newValue;
      }
    }
  },
  methods: {
    ...mapActions({
      FetchReport: "consumables/fetchManufacturingReport",
      FetchReportDetails: "consumables/fetchManufacturingReportDetails",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    resetErrors() {
        this.acountError = "";
        this.amountError = "";
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    setLabel() {
      if (this.filterData.time == "annual") {
        this.dashboardLabel = this.filterData.year+"'s";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "month") {
        this.dashboardLabel = "This month's";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "quarter") {
        this.dashboardLabel = "This quarter's";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "custom") {
        this.dashboardLabel = this.filterData.datefrom+' to '+this.filterData.dateto;
      }
    },

    FetchManufacturingReport(){
      this.FetchReport(this.filterData);
    },

    Excel_export() {
      axios
        .post("export_manufacturingreport", this.filterData,{
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "manufacturingreport.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {
        });
    },

    ExpandAccount(account){
      if(account){
        this.filterData.report = account;
        this.FetchReportDetails(this.filterData);
      }
    },

    ResetAccount(account){
      if(account){
        this.ReportDetails = [];
        this.filterData.report = "";
      }
    }
  },
  created() {
    this.FetchReport(this.filterData);
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row" style="font-size: medium;">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <h3 class="mb-4 text-center">{{dashboardLabel}} MANUFACTURING REPORT</h3>
            </div> 
            <div class="row py-5"> 
              <div class="col-md-2 mt-4">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                >
              </div>   
              <div class="col-md-2">
                <label>FILTER BY TIME</label>
                <model-list-select
                  :list="this.timeFilters ? this.timeFilters : []"
                  v-model="filterData.time"
                  option-value="value"
                  size="sm"
                  @input="setLabel(), FetchManufacturingReport()"
                  option-text="title"
                  placeholder="Select Performance"
                >
                </model-list-select>
              </div>
              <div class="col-md-3" v-show="filterData.time == 'annual'">
                <label>ENTER YEAR</label>
                <input type="year"
                  class="form-control"
                  v-model="filterData.year"
                  lang="en"
                  @keyup.enter="setLabel(), FetchManufacturingReport()"
                />
              </div>
              <div class="col-md-3" v-show="filterData.time == 'custom'">
                <label>FROM</label>
                <input type="date"
                  class="form-control"
                  v-model="filterData.datefrom"
                  lang="en"
                  @keyup.enter="setLabel(), FetchTransactions()"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-3" v-show="filterData.time == 'custom'">
                <label>TO</label>
                <input type="date"
                  class="form-control"
                  v-model="filterData.dateto"
                  lang="en"
                  @keyup.enter="setLabel(), FetchTransactions()"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-2 mt-4" align="right">
                <button class="btn btn-warning" type="button" @click="FetchManufacturingReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="FilterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>            
            <div v-if="ManufacturingReport && !FilterStatus" class="py-3">
              <table class="table-responsive table" align="center">
                <thead class="h4">
                  <tr>
                    <th>Particulars</th>
                    <th>Amount</th>
                  </tr>                  
                </thead>
                <tbody>
                  <tr class="h5">
                    <td>Opening Stock
                      <button class="btn btn-sm btn-link" @click="ExpandAccount('opening_stock')">
                          <b-spinner
                            v-if="FilterStatus"
                            variant="primary"
                            small
                            label="Spinning"
                          ></b-spinner>
                        <b> Expand <i class="fa fa-arrow-down"></i></b>
                      </button> 
                      <button class="btn btn-sm btn-link" @click="ResetAccount('opening_stock')">
                        <b> Collapse <i class="fa fa-arrow-up"></i></b>
                      </button>                                                                  
                    </td>
                    <td>{{ (ManufacturingReport?.opening_stock || 0).toLocaleString() }}</td>
                  </tr>
                  <template v-if="filterData.report === 'opening_stock'">
                    <tr v-for="(item, index) in ReportDetails" :key="index" style="font-size: 14px;">
                      <td>{{ item?item.item.name:'' }}</td>
                      <td>{{ item?((item.quantity_in*item.buying_price)-(item.quantity_out*item.buying_price)).toLocaleString():0 }}</td>
                    </tr> 
                  </template>
                  <tr class="h5">
                    <td>Purchases
                      <button class="btn btn-sm btn-link" @click="ExpandAccount('purchases')">
                          <b-spinner
                            v-if="FilterStatus"
                            variant="primary"
                            small
                            label="Spinning"
                          ></b-spinner>
                        <b> Expand <i class="fa fa-arrow-down"></i></b>
                      </button>
                      <button class="btn btn-sm btn-link" @click="ResetAccount('purchases')">
                        <b> Collapse <i class="fa fa-arrow-up"></i></b>
                      </button>                       
                    </td>
                    <td>{{ (ManufacturingReport?.purchases || 0).toLocaleString() }}</td>
                  </tr>
                  <template v-if="filterData.report === 'purchases'">
                    <tr v-for="(item, index) in ReportDetails" :key="index" style="font-size: 14px;">
                      <td>{{ item?item.item.name:'' }}</td>
                      <td>{{ item?(item.price).toLocaleString():0 }}</td>
                    </tr>
                  </template>
                  <tr class="h5">
                    <td>Cost of Services
                      <button class="btn btn-sm btn-link" @click="ExpandAccount('cost_of_services')">
                          <b-spinner
                            v-if="FilterStatus"
                            variant="primary"
                            small
                            label="Spinning"
                          ></b-spinner>
                        <b> Expand <i class="fa fa-arrow-down"></i></b>
                      </button>
                      <button class="btn btn-sm btn-link" @click="ResetAccount('cost_of_services')">
                        <b> Collapse <i class="fa fa-arrow-up"></i></b>
                      </button>                       
                    </td>
                    <td>{{ (ManufacturingReport?.cost_of_services || 0).toLocaleString() }}</td>
                  </tr>
                  <template v-if="filterData.report === 'cost_of_services'">
                    <tr v-for="(item, index) in ReportDetails" :key="index" style="font-size: 14px;">
                      <td>{{ item?item.item.name:'' }}</td>
                      <td>{{ item?(item.quantity*item.item.buying_price).toLocaleString():0 }}</td>
                    </tr>
                  </template>
                  <tr class="h5">
                    <td>Closing Stock
                      <button class="btn btn-sm btn-link" @click="ExpandAccount('closing_stock')">
                          <b-spinner
                            v-if="FilterStatus"
                            variant="primary"
                            small
                            label="Spinning"
                          ></b-spinner>
                        <b> Expand <i class="fa fa-arrow-down"></i></b>
                      </button>
                      <button class="btn btn-sm btn-link" @click="ResetAccount('closing_stock')">
                        <b> Collapse <i class="fa fa-arrow-up"></i></b>
                      </button>                       
                    </td>
                    <td class="text-danger">({{ (ManufacturingReport?.closing_stock || 0).toLocaleString() }})</td>
                  </tr>
                  <template v-if="filterData.report === 'closing_stock'">
                    <tr v-for="(item, index) in ReportDetails" :key="index" style="font-size: 14px;">
                      <td>{{ item?item.item.name:'' }}</td>
                      <td>{{ item?((item.quantity_in*item.buying_price).toFixed(2)-(item.quantity_out*item.buying_price).toFixed(2)).toLocaleString():0 }}</td>
                    </tr>
                  </template>
                  <tr class="h5">
                    <td>Cost of Raw Materials Consumed</td>
                    <td>{{ ManufacturingReport?((ManufacturingReport.opening_stock+ManufacturingReport.purchases+ManufacturingReport.cost_of_services)-(ManufacturingReport.closing_stock)).toLocaleString() : 0 }}</td>
                  </tr>
                  <tr class="h5">
                    <td>Cost of Additives Used</td>
                    <td>{{ ManufacturingReport?((ManufacturingReport.additives_opening_stock+ManufacturingReport.additives_purchases)-(ManufacturingReport.additives_closing_stock)).toLocaleString() : 0 }}</td>
                  </tr>
                  <tr class="h5">
                    <td>Other Direct Costs
                      <button class="btn btn-sm btn-link" @click="ExpandAccount('expenses')">
                          <b-spinner
                            v-if="FilterStatus"
                            variant="primary"
                            small
                            label="Spinning"
                          ></b-spinner>
                        <b> Expand <i class="fa fa-arrow-down"></i></b>
                      </button>    
                      <button class="btn btn-sm btn-link" @click="ResetAccount('expenses')">
                        <b> Collapse <i class="fa fa-arrow-up"></i></b>
                      </button>                  
                    </td>
                    <td>{{ (ManufacturingReport?.expenses || 0).toLocaleString() }}</td>
                  </tr>
                  <template v-if="filterData.report === 'expenses'">
                    <tr v-for="(item, index) in ReportDetails"
                        :key="index"
                        style="font-size: 14px;">
                      <td>{{ item?.category?.name || '' }}</td>
                      <td>{{ item?.amount?.toLocaleString() || 0 }}</td>
                    </tr>
                  </template>
                  <tr class="h5">
                    <td>Opening W.I.P
                      <button class="btn btn-sm btn-link" @click="ExpandAccount('openingWIP')">
                          <b-spinner
                            v-if="FilterStatus"
                            variant="primary"
                            small
                            label="Spinning"
                          ></b-spinner>
                        <b> Expand <i class="fa fa-arrow-down"></i></b>
                      </button>    
                      <button class="btn btn-sm btn-link" @click="ResetAccount('openingWIP')">
                        <b> Collapse <i class="fa fa-arrow-up"></i></b>
                      </button>                  
                    </td>
                    <td>{{ (ManufacturingReport?.opening_WIP || 0).toLocaleString() }}</td>
                  </tr>
                  <template v-if="filterData.report === 'openingWIP'">
                    <tr v-for="(item, index) in ReportDetails" :key="index" style="font-size: 14px;">
                      <td>{{ item?item.item.name:'' }}</td>
                      <td>{{ item?(item.quantity*item.item.buying_price).toLocaleString():0 }}</td>
                    </tr>
                  </template>
                  <tr class="h5">
                    <td>Closing W.I.P
                      <button class="btn btn-sm btn-link" @click="ExpandAccount('closingWIP')">
                          <b-spinner
                            v-if="FilterStatus"
                            variant="primary"
                            small
                            label="Spinning"
                          ></b-spinner>
                        <b> Expand <i class="fa fa-arrow-down"></i></b>
                      </button>    
                      <button class="btn btn-sm btn-link" @click="ResetAccount('closingWIP')">
                        <b> Collapse <i class="fa fa-arrow-up"></i></b>
                      </button>                  
                    </td>
                    <td class="text-danger">({{ (ManufacturingReport?.closing_WIP || 0).toLocaleString() }})</td>
                  </tr>
                  <template v-if="filterData.report === 'closingWIP'">
                    <tr v-for="(item, index) in ReportDetails" :key="index" style="font-size: 14px;">
                      <td>{{ item?item.item.name:'' }}</td>
                      <td>{{ item?(item.quantity*item.item.buying_price).toLocaleString():0 }}</td>
                    </tr>
                  </template>
                  <tr class="h5">
                    <td>Total Cost of Production</td>
                    <td>
                      <b>{{ ManufacturingReport ? ((ManufacturingReport.opening_stock + ManufacturingReport.purchases + ManufacturingReport.cost_of_services + ManufacturingReport.opening_WIP + ((ManufacturingReport.additives_opening_stock + ManufacturingReport.additives_purchases) - (ManufacturingReport.additives_closing_stock))) - (ManufacturingReport.closing_stock - ManufacturingReport.expenses + ManufacturingReport.closing_WIP)).toLocaleString() : 0 }}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Loader v-else />            
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>   
